import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationPersonalAnalysis: React.FC<
  React.PropsWithChildren<Props>
> = ({ theme, ...otherProps }) => {
  return (
    <svg
      width="304"
      height="304"
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path stroke="#C0C2C9" d="M12 297.5h290" />
      <path
        d="m280.294 54.075-1.748-2.875c-14.715-24.224-41.319-38.828-69.376-37.055-3.618.228-7.214.72-10.76 1.471-25.501 5.455-47.694 24.721-56.894 49.395-5.38 14.51-6.92 31.224-17.189 42.738-13.362 14.993-36.046 15.45-55.986 14.839-19.94-.611-42.643-.087-55.938 14.96-8.326 9.405-10.976 22.84-10.303 35.449 1.795 33.434 25.084 63.314 54.755 78.166 29.67 14.853 64.56 16.183 97.002 9.654 45.488-9.157 88.683-34.294 114.668-73.115 25.986-38.821 32.556-91.716 11.769-133.627Z"
        fill="#F0F1F3"
      />
      <circle cx={89} cy={76} r={27} fill="#F0F1F3" />
      <circle cx={267} cy={244} r={21} fill="#F0F1F3" />
      <circle cx={25.5} cy={266.5} r={23.5} fill="#F0F1F3" />
      <g filter="url(#a)">
        <path
          d="M296.62 52h-51.39a5.23 5.23 0 0 0-5.23 5.23v58.87a5.23 5.23 0 0 0 5.23 5.23h51.39a5.23 5.23 0 0 0 5.23-5.23V57.23a5.23 5.23 0 0 0-5.23-5.23Z"
          fill="#fff"
        />
      </g>
      <path
        d="M267.79 80.12h1.5l3.27-4.55v-3s2.31-.14 2 3.76c-.31 3.9 0 2.91 0 2.91s4.9 0 5.31.45c.41.45.43 5.18.48 7.82a2.848 2.848 0 0 1-2 2.88 1.856 1.856 0 0 1-.52.07c-1.23 0-7.48-1-7.48-1h-2.58l.02-9.34ZM263.52 79.3l.92 10.22h2.55V79.5l-3.47-.2Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M270.93 57.46a24.197 24.197 0 0 0-22.365 14.932 24.198 24.198 0 0 0 17.63 33.002 24.2 24.2 0 1 0 4.735-47.934Zm.36 38.7a14.872 14.872 0 0 1-14.595-17.765 14.866 14.866 0 0 1 11.681-11.688 14.867 14.867 0 0 1 15.267 6.32 14.866 14.866 0 0 1 2.507 8.263 14.85 14.85 0 0 1-4.349 10.514 14.855 14.855 0 0 1-10.511 4.356Z"
        fill="#E9EAEC"
      />
      <path
        d="M271.3 57.47v9a14.893 14.893 0 0 1 14.636 12.448c.382 2.3.219 4.657-.476 6.882l8.77 2.38a24.21 24.21 0 0 0-22.93-30.71ZM256.43 81.29c.001-2.871.833-5.68 2.396-8.09a14.867 14.867 0 0 1 6.414-5.48l-3.68-8.31a24.203 24.203 0 0 0-14.79 22.3v1h9.73c-.047-.473-.07-.947-.07-1.42Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M271.29 96.16c-1.056 0-2.108-.114-3.14-.34-.38 2.16-1.08 6.33-1.64 9.62 1.458.274 2.937.411 4.42.41a24.208 24.208 0 0 0 23.3-17.67l-8.77-2.38a14.877 14.877 0 0 1-14.17 10.36Z"
        fill="#DBDDE1"
      />
      <path
        d="M290.95 111.96c0 .13-9 .23-20 .23s-20-.1-20-.23 9-.23 20-.23 20 .1 20 .23ZM282.03 115.64c0 .12-5 .22-11.1.22s-11.11-.1-11.11-.22 5-.23 11.11-.23c6.11 0 11.1.1 11.1.23Z"
        fill="#222"
      />
      <g filter="url(#b)">
        <path
          d="M252.1 186h-52.87a5.23 5.23 0 0 0-5.23 5.23v60.52a5.23 5.23 0 0 0 5.23 5.23h52.87a5.23 5.23 0 0 0 5.23-5.23v-60.52a5.23 5.23 0 0 0-5.23-5.23Z"
          fill="#fff"
        />
      </g>
      <path
        d="M231.36 219.75h-1.53l-3.34 4.65v3.05s-2.37.15-2.09-3.85c.28-4 0-3 0-3s-5 0-5.44-.46c-.44-.46-.44-5.3-.49-8a2.925 2.925 0 0 1 .509-1.863 2.924 2.924 0 0 1 1.561-1.137 2.1 2.1 0 0 1 .54-.08c1.26 0 7.65 1 7.65 1h2.65l-.02 9.69ZM235.74 220.58l-.95-10.46h-2.61v10.25l3.56.21Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M226.74 192.48a24.783 24.783 0 0 0-24.303 29.618 24.782 24.782 0 1 0 33.785-27.735 24.758 24.758 0 0 0-9.482-1.883Zm.38 39.62a15.225 15.225 0 0 1-14.061-9.396 15.22 15.22 0 1 1 14.031 9.396h.03Z"
        fill="#E9EAEC"
      />
      <path
        d="M227.09 192.49v9.17a15.221 15.221 0 0 1 15.22 15.22 14.934 14.934 0 0 1-.72 4.61l9 2.44a24.75 24.75 0 0 0-4.003-21.498 24.753 24.753 0 0 0-19.477-9.942h-.02ZM211.87 216.88a15.217 15.217 0 0 1 9-13.9l-3.81-8.56a24.781 24.781 0 0 0-15.14 22.83v1h10a13.05 13.05 0 0 1-.05-1.37Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M227.09 232.1a14.848 14.848 0 0 1-3.22-.35c-.38 2.21-1.11 6.49-1.68 9.86a24.75 24.75 0 0 0 28.38-17.68l-9-2.44a15.216 15.216 0 0 1-14.48 10.61Z"
        fill="#DBDDE1"
      />
      <path
        d="M247.21 248.33c0 .13-9.17.23-20.49.23-11.32 0-20.5-.1-20.5-.23s9.17-.24 20.5-.24 20.49.06 20.49.24ZM238.08 252.04c0 .13-5.09.24-11.36.24s-11.38-.11-11.38-.24 5.09-.23 11.38-.23c6.29 0 11.36.1 11.36.23Z"
        fill="#222"
      />
      <g filter="url(#c)">
        <path
          d="M202.43 91H138.1a9.094 9.094 0 0 0-8.41 5.616 9.093 9.093 0 0 0-.69 3.484v47a9.097 9.097 0 0 0 5.615 8.416 9.101 9.101 0 0 0 3.485.694h48.83l12.94 9.86v-9.86h2.56a9.124 9.124 0 0 0 6.442-2.668 9.108 9.108 0 0 0 2.668-6.442v-47a9.099 9.099 0 0 0-9.11-9.1Z"
          fill="#fff"
        />
      </g>
      <path
        d="M184.46 147.75h-28.39a2.316 2.316 0 0 1-1.64-.68 2.316 2.316 0 0 1 0-3.28 2.316 2.316 0 0 1 1.64-.68h28.39c.615 0 1.205.244 1.64.68a2.316 2.316 0 0 1 0 3.28 2.316 2.316 0 0 1-1.64.68Z"
        fill="#DBDDE1"
      />
      <path
        d="M177.29 147.75h-21.22a2.316 2.316 0 0 1-1.64-.68 2.316 2.316 0 0 1 0-3.28 2.316 2.316 0 0 1 1.64-.68h21.22c.615 0 1.205.244 1.64.68a2.316 2.316 0 0 1 0 3.28 2.316 2.316 0 0 1-1.64.68ZM170.27 138.49c9.776 0 17.7-7.925 17.7-17.7 0-9.775-7.924-17.7-17.7-17.7-9.775 0-17.7 7.925-17.7 17.7 0 9.775 7.925 17.7 17.7 17.7Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M163.4 116.74a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44ZM176.51 116.74a1.72 1.72 0 1 0 0-3.44 1.72 1.72 0 0 0 0 3.44Z"
        fill="#222"
      />
      <path
        opacity={0.4}
        d="M160.52 121.96s.15 9 10 8.92c9.85-.08 10-8.92 10-8.92a86.534 86.534 0 0 0-20 0Z"
        fill="#222"
      />
      <path
        d="M163 128.09s2.18-2 7.66-2 7.19 1.94 7.19 1.94a9.106 9.106 0 0 1-7.47 2.8c-5.84-.27-7.38-2.74-7.38-2.74Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M160.52 121.96s.15 9 10 8.92c9.85-.08 10-8.92 10-8.92a86.534 86.534 0 0 0-20 0Z"
        stroke="#222"
        strokeWidth={0.5}
        strokeLinejoin="round"
      />
      <g filter="url(#d)">
        <path
          d="M140.27 193H98.86a11.854 11.854 0 0 0-8.39 3.477A11.87 11.87 0 0 0 87 204.87v27.7a11.86 11.86 0 0 0 11.86 11.88h1.69v7.79l10.21-7.79h29.51a11.87 11.87 0 0 0 11.87-11.87v-27.7a11.879 11.879 0 0 0-3.473-8.4 11.873 11.873 0 0 0-8.397-3.48Z"
          fill="#fff"
        />
      </g>
      <path
        d="M120.24 235.89c9.56 0 17.31-7.75 17.31-17.31 0-9.56-7.75-17.31-17.31-17.31-9.56 0-17.31 7.75-17.31 17.31 0 9.56 7.75 17.31 17.31 17.31Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M115.21 212.93a1.69 1.69 0 0 1-2.014 1.669 1.695 1.695 0 0 1-1.239-2.303c.128-.31.344-.574.623-.76a1.693 1.693 0 0 1 2.63 1.394ZM126.35 214.61a1.68 1.68 0 1 0 0-3.36 1.68 1.68 0 0 0 0 3.36ZM127.46 220.11c-2.408.257-4.83.344-7.25.26a51.324 51.324 0 0 1-7.25-.26 49.73 49.73 0 0 1 7.25-.26 49.73 49.73 0 0 1 7.25.26Z"
        fill="#222"
      />
      <g filter="url(#e)">
        <path
          d="M61.15 124.31H11.6a9.53 9.53 0 0 0-9.53 9.53V169a9.53 9.53 0 0 0 9.53 9.53h.17v8.21l10.76-8.21h38.62a9.54 9.54 0 0 0 9.54-9.53v-35.16a9.53 9.53 0 0 0-9.54-9.53Z"
          fill="#fff"
        />
      </g>
      <path
        d="M51.14 148.32a9 9 0 0 0-2.19-5 8.741 8.741 0 0 0-4.48-3 7.091 7.091 0 0 0-7.91 3.41 7.06 7.06 0 0 0-2-2.35 7.22 7.22 0 0 0-5.5-1.25 8.777 8.777 0 0 0-4.66 2.67 9.15 9.15 0 0 0-2.49 4.89 11 11 0 0 0 1.17 6.87 15.694 15.694 0 0 0 5.26 5.24c3.47 2.24 8 5.05 8 5.05s4-2.82 7.63-4.85a15.765 15.765 0 0 0 5.57-4.9 11.15 11.15 0 0 0 1.6-6.78Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <g filter="url(#f)">
        <path
          d="M145.41 13.71H100a9.521 9.521 0 0 0-9.53 9.53v31.84a9.529 9.529 0 0 0 9.53 9.54h35.71l10.11 7.7V64.6a9.53 9.53 0 0 0 9.11-9.52V23.24a9.523 9.523 0 0 0-9.52-9.53Z"
          fill="#fff"
        />
      </g>
      <path
        d="M138.86 51.67h-31.82a2.47 2.47 0 0 0-2.47 2.47v.23a2.47 2.47 0 0 0 2.47 2.47h31.82a2.47 2.47 0 0 0 2.47-2.47v-.23a2.47 2.47 0 0 0-2.47-2.47Z"
        fill="#DBDDE1"
      />
      <path
        d="M114.85 51.67h-7.81a2.47 2.47 0 0 0-2.47 2.47v.23a2.47 2.47 0 0 0 2.47 2.47h7.81a2.47 2.47 0 0 0 2.47-2.47v-.23a2.47 2.47 0 0 0-2.47-2.47ZM135.807 37.614c1.775-7.475-2.845-14.973-10.32-16.748-7.474-1.775-14.972 2.845-16.747 10.32-1.776 7.474 2.845 14.972 10.319 16.747 7.474 1.775 14.973-2.845 16.748-10.32Z"
        fill={theme ? theme.primary[500] : '#C0C2C9'}
      />
      <path
        d="M118.67 35a1.345 1.345 0 0 1-.834 1.247 1.35 1.35 0 1 1-.516-2.597 1.358 1.358 0 0 1 1.35 1.35ZM127.43 36.3a1.35 1.35 0 1 0 0-2.7 1.35 1.35 0 0 0 0 2.7ZM126.63 40.33c-.06.05-.38-.37-1-.82a4.69 4.69 0 0 0-5.76.24c-.62.51-.91 1-1 .91-.09-.09.12-.55.73-1.18a4.58 4.58 0 0 1 6.24-.26c.63.57.84 1.08.79 1.11Z"
        fill="#222"
      />
      <path
        d="M128.5 32.18c.09.11-.58.85-1.5 1.66-.92.81-1.75 1.37-1.85 1.26-.1-.11.58-.85 1.51-1.65.93-.8 1.74-1.37 1.84-1.27ZM119.49 35.24c-.11.1-.88-.53-1.73-1.42-.85-.89-1.46-1.67-1.36-1.77.1-.1.88.53 1.73 1.41.85.88 1.46 1.68 1.36 1.78Z"
        fill="#222"
      />
      <defs>
        <filter
          id="a"
          x={238}
          y={50.5}
          width={65.85}
          height={73.33}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
        <filter
          id="b"
          x={192}
          y={184.5}
          width={67.33}
          height={74.98}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
        <filter
          id="c"
          x={127}
          y={89.5}
          width={86.54}
          height={79.07}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
        <filter
          id="d"
          x={85}
          y={191.5}
          width={69.14}
          height={63.24}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
        <filter
          id="e"
          x={0.07}
          y={122.81}
          width={72.62}
          height={66.43}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
        <filter
          id="f"
          x={88.47}
          y={12.21}
          width={68.46}
          height={62.61}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={0.5} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1269_12759"
          />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation={0.5} />
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0" />
          <feBlend
            in2="effect1_dropShadow_1269_12759"
            result="effect2_dropShadow_1269_12759"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1269_12759"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default IllustrationPersonalAnalysis;
